// src/Component/NotificationTest.js
import React, { useState } from 'react';
import { useNotifications } from '../hooks/useNotifications';
import notificationUtils from '../utils/notificationUtils';

const NotificationTest = () => {
  const [testResult, setTestResult] = useState('');
  const {
    isSupported,
    isEnabled,
    fcmToken,
    isLoading,
    requestPermission
  } = useNotifications();

  const handleTestNotification = () => {
    try {
      const notification = notificationUtils.showTestNotification();
      if (notification) {
        setTestResult('Test notification sent successfully!');
      } else {
        setTestResult('Notifications not enabled or supported.');
      }
    } catch (error) {
      setTestResult(`Error: ${error.message}`);
    }
  };

  const handleRequestPermission = async () => {
    try {
      setTestResult('Requesting permission...');
      const success = await requestPermission();
      if (success) {
        setTestResult('Permission granted successfully!');
      } else {
        setTestResult('Permission denied or failed.');
      }
    } catch (error) {
      setTestResult(`Error: ${error.message}`);
    }
  };

  const copyTokenToClipboard = () => {
    if (fcmToken) {
      navigator.clipboard.writeText(fcmToken);
      setTestResult('FCM Token copied to clipboard!');
    }
  };

  if (isLoading) {
    return <div>Loading notification test...</div>;
  }

  return (
    <div style={{ padding: '20px', border: '1px solid #ddd', margin: '20px', borderRadius: '8px' }}>
      <h3>Firebase Notification Test</h3>
      
      <div style={{ marginBottom: '15px' }}>
        <strong>Status:</strong>
        <ul>
          <li>Supported: {isSupported ? '✅' : '❌'}</li>
          <li>Enabled: {isEnabled ? '✅' : '❌'}</li>
          <li>Has Token: {fcmToken ? '✅' : '❌'}</li>
        </ul>
      </div>

      {fcmToken && (
        <div style={{ marginBottom: '15px' }}>
          <strong>FCM Token:</strong>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input 
              type="text" 
              value={fcmToken} 
              readOnly 
              style={{ 
                width: '300px', 
                padding: '5px',
                marginRight: '10px',
                fontSize: '12px'
              }}
            />
            <button onClick={copyTokenToClipboard}>Copy</button>
          </div>
        </div>
      )}

      <div style={{ marginBottom: '15px' }}>
        <button 
          onClick={handleRequestPermission}
          disabled={isEnabled}
          style={{
            padding: '10px 15px',
            marginRight: '10px',
            backgroundColor: isEnabled ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: isEnabled ? 'not-allowed' : 'pointer'
          }}
        >
          {isEnabled ? 'Already Enabled' : 'Request Permission'}
        </button>

        <button 
          onClick={handleTestNotification}
          disabled={!isEnabled}
          style={{
            padding: '10px 15px',
            backgroundColor: isEnabled ? '#28a745' : '#ccc',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: isEnabled ? 'pointer' : 'not-allowed'
          }}
        >
          Send Test Notification
        </button>
      </div>

      {testResult && (
        <div style={{
          padding: '10px',
          backgroundColor: testResult.includes('Error') ? '#ffebee' : '#e8f5e8',
          border: `1px solid ${testResult.includes('Error') ? '#f44336' : '#4caf50'}`,
          borderRadius: '4px',
          marginTop: '10px'
        }}>
          {testResult}
        </div>
      )}

      <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        <strong>Instructions:</strong>
        <ol>
          <li>Click "Request Permission" to enable notifications</li>
          <li>Click "Send Test Notification" to test local notifications</li>
          <li>Copy the FCM token to test server-side notifications</li>
          <li>Use Firebase Console to send test messages to the token</li>
        </ol>
      </div>
    </div>
  );
};

export default NotificationTest;
